import React from 'react';
import { Link } from 'react-router-dom';
import './ContentItem.css';

function ContentItem({ item }) {
  if (!item || !item.category) {
    return null;
  }

  return (
    <Link to={`/categories/${item.category}/${item.id}`} className="content-item-link">
      <article className="content-item">
        <h2>{item.title}</h2>
        <p className="brief">{item.brief}</p>
        {item.details && <p className="details">{item.details}</p>}
        {item.tags && item.tags.length > 0 && (
          <div className="tags">
            {item.tags.map(tag => (
              <span key={tag} className="tag">{tag}</span>
            ))}
          </div>
        )}
        {item.category === 'ai-generated' && (
          <p className="ai-disclaimer"><em>*本条由AI生成，仅供娱乐。</em></p>
        )}
      </article>
    </Link>
  );
}

export default ContentItem;
